import Form from 'src/utils/Form.js'

class Help extends Form {
  constructor(data, config = null) {
    super(data, config || Form.config)
  }

  fetch(then) {
    return super.get(`helps/${this.id}/edit`).then(data => {
      this.originalData = data
      for (let field in this.originalData) {
        this[field] = data[field]
      }
      then(data)
    })
  }

  static all(parameters, then) {
    return new Form().get(`helps?${parameters}`).then(then)
  }

  create(then) {
    return super.post(`helps`).then(then)
  }

  update(then) {
    return super.patch(`helps/${this.id}`).then(then)
  }

  updateInline(then) {
    return super.put(`helps/${this.id}`).then(then)
  }

  destroy(then) {
    return super.delete(`helps/${this.id}`).then(then)
  }

  static getIndex(then) {
    return new Form().get('help-and-support').then(then)
  }

  static getCategoryArticles(slug, then) {
    return new Form().get('help-and-support/' + slug).then(then)
  }

  static show(slug, then) {
    return new Form().get(`help-and-support/${slug}`).then(then)
  }

  static search(val, then) {
    return new Form().get('help-and-support/search?filter=' + val).then(then)
  }
}

export default Help
